import React from "react";
import { InfiniteListProvider, type ListDataFetcher, type FetcherParams } from "components/List";
import ListPageHeader from "./Header";
import { cn } from "lib/utils";

interface Props {
    title: string;
    titleHighlight?: string;
    subtitle?: string;
    dataFetcher: ListDataFetcher;
    defaultFetcherParams: FetcherParams;
    cacheKey: string;
    className?: string;
    children: React.ReactNode;
}

const InfiniteListPage: React.FC<Props> = ({
    title,
    titleHighlight,
    subtitle,
    dataFetcher,
    defaultFetcherParams,
    cacheKey,
    className,
    children,
}) => (
    <div className={cn("min-h-screen", className)}>
        <div className="py-10 sm:py-12">
            <div className="mx-auto w-full max-w-[1400px] px-4 sm:px-6 lg:px-8">
                <ListPageHeader title={title} titleHighlight={titleHighlight} subtitle={subtitle} />
                <div className="mt-8">
                    <InfiniteListProvider
                        dataFetcher={dataFetcher}
                        defaultFetcherParams={defaultFetcherParams}
                        cacheKey={cacheKey}
                    >
                        {children}
                    </InfiniteListProvider>
                </div>
            </div>
        </div>
    </div>
);

export default InfiniteListPage;
